export default __webpack_public_path__ + "static/media/banner3.2addae67.jpg";